var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59.5,
    height: 59,
    viewBox: "0 0 119 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5008 116.386C91.2546 116.386 116.996 90.6741 116.996 58.9571C116.996 27.24 91.2546 1.52832 59.5008 1.52832C27.747 1.52832 2.00537 27.24 2.00537 58.9571C2.00537 90.6741 27.747 116.386 59.5008 116.386Z",
    stroke: "#EEEEEE",
    strokeWidth: 2.06357,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0273 25.5171V29.3435H49.2279V84.532C49.2279 90.2635 53.8855 94.9156 59.6236 94.9156C65.3617 94.9156 70.0192 90.2716 70.0192 84.532V29.3435H73.2198V25.5171H46.0355H46.0273ZM66.3849 35.4265H52.8459V29.3517H66.3849V35.4265Z",
    fill: "#9A4A0F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3034 84.5402C66.3034 88.2276 63.3156 91.2119 59.6239 91.2119C55.9323 91.2119 52.9445 88.2276 52.9445 84.5402L52.8545 81.5886V38.4517H66.3934V81.5886L66.3034 84.5402Z",
    fill: "#FFC469"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4165 42.9072V81.5882",
    stroke: "white",
    strokeWidth: 2.06357,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlood);
export default __webpack_public_path__ + "static/media/blood.f74233e33d84c85b8179cb43c81f46f1.svg";
export { ForwardRef as ReactComponent };